import React, { useEffect, useState } from "react";
import {
  Table,
  Toggle,
  TagPicker,
  VStack,
  HStack,
  Input,
  DateInput,
  Header,
  Heading,
  Button,
  Text,
  SelectPicker,
  Popover,
  Whisper,
  Modal,
  toaster,
  Message
} from "rsuite";
import axios from "../axiosIn";
import { variables } from "../Variables";
import moment from "moment/moment";
import { Image } from "react-bootstrap";
import { LuCheck, LuTrash } from "react-icons/lu";

export const ResumenIngresos = () => {
  const [loading, setLoading] = useState(false);
  const [fec1, setFec1] = useState("");
  const [fec2, setFec2] = useState("");
  const { Column, HeaderCell, Cell } = Table;
  const [data, setData] = useState([]);
  const [dataDetalles, setDataDetalles] = useState([]);
  const [totEfec, setTotEfec] = useState("$0.00");
  const [totBanco, setTotBanco] = useState("$0.00");
  const [total, setTotal] = useState("$ 0.00");
  const [detalleTitulo, setDetalleTitulo] = useState("Detalle de pagos");
  const [filtroForma, setFiltroForma] = useState("Todos");
  const [dataForma, setDataForma] = useState([]);
  const [dataEstatus] = useState([
    { label: "Sin Validar", value: "SIN VALIDAR" },
    { label: "Validados", value: "VALIDADO" },
    { label: 'Descargados', value: 'DESCARGADA'}
  ]);
  const [valueEstatus, setValueEstatus] = useState("SIN VALIDAR");

  const [sortColumn, setSortColumn] = React.useState();
  const [sortType, setSortType] = React.useState();
  const [curp, setCurp] = useState("");
  const [fileImage, setFileImage] = useState("");

  const [fecha, setFecha] = useState("");
  const [formaPago, setFormaPago] = useState("");

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const validSession = () => {
    var sessionID = getCookie("sessionID");
    var expira = getCookie("expira");
    var user = getCookie("user");
    var dateIsAfter = moment(new Date()).isAfter(moment(expira));

    if (sessionID.length === 0) {
      window.location = `/#/Login`;
      window.location.reload();
    }

    if (expira.length > 0) {
      if (dateIsAfter) {
        window.location = `/#/Login`;
        window.location.reload();
      }
    }
  };

  const getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  const getFechas = async () => {
    var url = `Registro/GetFechas`;
    await axios
      .get(url)
      .then((res) => {
        setFec1(stringToDate(res.data.fec1, "dd/MM/yyyy", "/"));
        setFec2(stringToDate(res.data.fec2, "dd/MM/yyyy", "/"));
      })
      .catch((err) => console.error(err));
  };

  const stringToDate = (_date, _format, _delimiter) => {
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf("mm");
    var dayIndex = formatItems.indexOf("dd");
    var yearIndex = formatItems.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(
      dateItems[yearIndex],
      month,
      dateItems[dayIndex]
    );
    return formatedDate;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const getDataIngresos = async () => {
    var f1 = new Date(fec1).toISOString();
    var f2 = new Date(fec2).toISOString();
    setDataDetalles([]);
    setLoading(true);

    var url = `${variables.API_URL}Registro/GetIngresos`;
    var datos = JSON.stringify({
      fec1: f1.substring(0, 10),
      fec2: f2.substring(0, 10),
      estatus: valueEstatus,
      formaPago: filtroForma,
    });

    await axios
      .post(url, datos, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setTotEfec(res.data.efec);
        setTotBanco(res.data.bancos);
        setTotal(res.data.total);
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const getData = () => {
    if (sortColumn && sortType) {
      return data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return data;
  };

  const getDetalles = async (fecha, formaPago) => {
    setFecha(fecha);
    setFormaPago(formaPago);
    var auth = valueEstatus === 'VALIDADO' ? 1 : 0;
    var fec = fecha.replace('.','-').replace('.','-');
    var fecFinal = fec.split('-');
    var _fecha = fecFinal[2] + '-' + fecFinal[1] + '-' + fecFinal[0];

    var url = `${variables.API_URL}Registro/GetDetallePagos`;
    setDetalleTitulo("Detalle de pagos: " + fecha + " (" + formaPago + ")");

    var datos = {
      fec1: _fecha,
      estatus: valueEstatus,
      formaPago: formaPago,
      auth: auth
    };

    await axios
      .post(url, datos)
      .then((res) => {
        setDataDetalles(res.data);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const handleChangeEstat = (e) => {
    if (e === null) {
      return;
    }
    setValueEstatus(e);
  };

  const NameCell = ({ rowData, dataKey, ...props }) => {
    const speaker = (
      <Popover title="Descripción">
        <p>
          <b>Nombre:</b> {rowData.nombre}
        </p>
        <p>
          <b>Equipo:</b> {rowData.equipo}
        </p>
        <p>
          <b>Categoría:</b> {rowData.categoria}
        </p>
      </Popover>
    );

    return (
      <Cell {...props}>
        <Whisper placement="top" speaker={speaker}>
          <a>{rowData[dataKey]}</a>
        </Whisper>
      </Cell>
    );
  };

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div
        style={{
          width: 40,
          height: 40,
          background: "#f5f5f5",
          borderRadius: 6,
          marginTop: 2,
          overflow: "hidden",
          display: "inline-block",
          cursor: "pointer",
        }}
      >
        <img
          src={`${variables.PHOTO_URL}/${rowData.curp}/${rowData.docPago}`}
          style={{ width: "20px" }}
          onClick={() => handleOpenModal(rowData.curp, rowData.docPago)}
        />
      </div>
    </Cell>
  );

  const setInformation = (curp, file) => {
    setCurp(curp);
    setFileImage(file);
  };

  const handleOpenModal = (curp, file) => {
    setCurp(curp);
    setFileImage(file);
    setOpen(true);
  };

  const handleValidated = async (id, auth) => {
    var url = `${variables.API_URL}Registro/Validar/${id}/${auth}`;
    await axios
      .get(url)
      .then(async (response) => {
        if (response.data === 1) {
          toast("El registro se actualizo de forma correcta", "info");
          await getDetalles(fecha, formaPago);
        }
      })
      .catch((err) => console.error(err));
  };

  const toast = (msg, type = "info") => {
      toaster.push(
        <Message showIcon type={type} closable>
          <strong>{type}!</strong>
          &nbsp; {msg}
        </Message>,
        { duration: 5000, placement: "topCenter" }
      );
    };

  useEffect(() => {
    let filtros = [];
    filtros.push({ label: "Todos", value: "Todos" });
    filtros.push({ label: "Banco", value: "Banco" });
    filtros.push({ label: "Efectivo", value: "Efectivo" });
    setDataForma(filtros);
    getFechas();
  }, [validSession()]);

  return (
    <main className="flex min-h-screen items-center justify-center p-3">
      <>
        <Header
          style={{
            backgroundColor: "#f9f7f6",
            height: "auto",
            padding: "20px",
            borderRadius: "15px",
          }}
        >
          <div class="col">
            <Heading>Conciliación de Ingresos</Heading>
          </div>
        </Header>
        <div className="row mb-1">&nbsp;</div>
        <div className="App">
          <div className="App container">
            <div className="card">
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-lg-2 col-md-2 col-sm-2">
                    <b>Del</b>
                    <DateInput
                      format="dd/MM/yyyy"
                      id="fec1"
                      name="fec1"
                      autoFocus="true"
                      value={fec1}
                      onChange={(e) => setFec1(e)}
                    />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-2">
                    <b>Al</b>
                    <DateInput
                      format="dd/MM/yyyy"
                      id="fec2"
                      name="fec2"
                      value={fec2}
                      onChange={(e) => setFec2(e)}
                    />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-2">
                    <b>Filtro por Estatus</b>
                    <SelectPicker
                      data={dataEstatus}
                      block
                      searchable={false}
                      defaultValue={valueEstatus}
                      onChange={(e) => handleChangeEstat(e)}
                      style={{ width: "99%" }}
                      placeholder="Selecciona una opción"
                    />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-3">
                    <b>Filtro por forma de pago</b>
                    <SelectPicker
                      data={dataForma}
                      defaultValue={"Todos"}
                      block
                      searchable={false}
                      onChange={(e) => setFiltroForma(e)}
                      placeholder="Selecciona una opción"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="col-lg-2 col-md-2 col-sm-2">
                    <br></br>
                    <Button
                      appearance="primary"
                      className="w-100"
                      loading={loading}
                      onClick={() => getDataIngresos()}
                    >
                      Buscar
                    </Button>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="text-end col-lg-2 col-md-2 col-sm-2">
                    <b style={{ fontSize: "16px" }}>Total Efectivo</b>
                    <Text
                      style={{ textAlign: "right" }}
                      weight="extrabold"
                      size="xl"
                    >
                      {totEfec}
                    </Text>
                  </div>
                  <div className="text-end col-lg-2 col-md-2 col-sm-2">
                    <b style={{ fontSize: "16px" }}>Total Bancos</b>
                    <Text
                      style={{ textAlign: "right" }}
                      weight="extrabold"
                      size="xl"
                    >
                      {totBanco}
                    </Text>
                  </div>
                  <div className="text-end col-lg-2 col-md-2 col-sm-2">
                    <b style={{ fontSize: "16px" }}>Total Periodo</b>
                    <Text
                      style={{ textAlign: "right" }}
                      weight="extrabold"
                      size="xl"
                    >
                      {total}
                    </Text>
                  </div>
                  <div className="text-center col-lg-6 col-md-6 col-sm-6">
                    <br></br>
                    <Text size="xxl">{detalleTitulo}</Text>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <Table
                      height={420}
                      data={getData()}
                      sortColumn={sortColumn}
                      sortType={sortType}
                      onSortColumn={handleSortColumn}
                      loading={loading}
                      bordered
                      cellBordered
                      fixed
                      onRowClick={(rowData) => {
                        getDetalles(rowData.fecha, rowData.formaPago);
                      }}
                    >
                      <Column
                        align="center"
                        fixed
                        sortable
                        flexGrow={true}
                        width={90}
                      >
                        <HeaderCell>Fecha</HeaderCell>
                        <Cell
                          dataKey="fecha"
                          style={{ cursor: "pointer", color: "blue" }}
                        />
                      </Column>

                      <Column fixed sortable align="center" flexGrow={true}>
                        <HeaderCell>Pagos</HeaderCell>
                        <Cell dataKey="pagos" />
                      </Column>

                      <Column sortable flexGrow={true}>
                        <HeaderCell>Forma de pago</HeaderCell>
                        <Cell dataKey="formaPago" />
                      </Column>

                      <Column sortable align="right" flexGrow={true}>
                        <HeaderCell>Monto</HeaderCell>
                        <Cell dataKey="monto" />
                      </Column>
                    </Table>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6">
                    <Table
                      height={420}
                      data={dataDetalles}
                      sortColumn={sortColumn}
                      sortType={sortType}
                      onSortColumn={handleSortColumn}
                      loading={loading}
                      bordered
                      cellBordered
                      fixed
                    >
                      <Column align="center" fixed sortable width={100}>
                        <HeaderCell>#</HeaderCell>
                        <Cell dataKey="registro" />
                      </Column>

                      <Column fixed sortable flexGrow={true} resizable>
                        <HeaderCell>Nombre</HeaderCell>
                        <NameCell dataKey="nombre" />
                      </Column>

                      <Column align="center" flexGrow={true} resizable>
                        <HeaderCell align="center">Comprobante</HeaderCell>
                        <ImageCell
                          dataKey="docPago"
                          align="center"
                          style={{ cursor: "pointer" }}
                        />
                      </Column>

                      <Column sortable align="right" flexGrow={true}>
                        <HeaderCell>Monto</HeaderCell>
                        <Cell dataKey="monto" />
                      </Column>

                      <Column width={80} fixed="center">
                        <HeaderCell align="center">Validado</HeaderCell>
                        <Cell style={{ padding: "6px" }} align="center">
                          {(rowData) => (
                            <Button
                              appearance="ghost"
                              size="sm"
                              onClick={() =>
                                handleValidated(rowData.registro, 1)
                              }
                            >
                              <LuCheck />
                            </Button>
                          )}
                        </Cell>
                      </Column>
                      <Column width={80} fixed="center">
                        <HeaderCell align="center">Rechazado</HeaderCell>
                        <Cell style={{ padding: "6px" }} align="center">
                          {(rowData) => (
                            <Button
                              appearance="ghost"
                              color="red"
                              size="sm"
                              onClick={() =>
                                handleValidated(rowData.registro, 0)
                              }
                            >
                              <LuTrash />
                            </Button>
                          )}
                        </Cell>
                      </Column>
                    </Table>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Button
                      appearance="ghost"
                      className="w-100"
                      color="blue"
                      style={{ border: "none", fontSize: "16px" }}
                      onClick={() => {
                        window.history.go(-1);
                      }}
                    >
                      Regresar a menú
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          backdrop="static"
          keyboard={true}
          open={open}
          onClose={handleClose}
          overflow={false}
          size={"sm"}
          overflowY={true}
        >
          <Modal.Header>
            <Modal.Title>Comprobante de pago</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row mb-3">
              <div className="col">
                <Image
                  src={`${variables.PHOTO_URL}/${curp}/${fileImage}`}
                  width={"320px"}
                  height={"450px"}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose} appearance="subtle">
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </main>
  );
};
